"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionVariationRow = exports.VariationRow = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var styled_components_1 = __importDefault(require("styled-components"));
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var utilities_1 = require("../../utilities");
var common_1 = require("../common");
exports.VariationRow = (0, styled_components_1.default)(aon_tws_common_ui_1.TableRow)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\ttd {\n\t\tbackground-color: #f6f6f6;\n\n\t\t:first-child {\n\t\t\t", ";\n\t\t\tpadding-left: 10px !important;\n\t\t}\n\n\t\t:nth-child(2) {\n\t\t\t", ";\n\t\t}\n\n\t\t:last-child {\n\t\t\tborder-right: 10px solid #ffffff !important;\n\t\t}\n\t}\n"], ["\n\ttd {\n\t\tbackground-color: #f6f6f6;\n\n\t\t:first-child {\n\t\t\t", ";\n\t\t\tpadding-left: 10px !important;\n\t\t}\n\n\t\t:nth-child(2) {\n\t\t\t", ";\n\t\t}\n\n\t\t:last-child {\n\t\t\tborder-right: 10px solid #ffffff !important;\n\t\t}\n\t}\n"])), function (props) { return (!props.selectable ? "border-left: 10px solid #ffffff !important" : ''); }, function (props) { return (props.selectable ? "border-left: 10px solid #ffffff !important" : ''); });
exports.VariationRow.displayName = 'TableRow';
var QuestionVariationRow = /** @class */ (function (_super) {
    __extends(QuestionVariationRow, _super);
    function QuestionVariationRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            visibleColumns: utilities_1.ColumnHelper.GetSelectedColumns(_this.props.columns),
        };
        _this.GetMissingLanguages = _this.GetMissingLanguages.bind(_this);
        return _this;
    }
    QuestionVariationRow.getDerivedStateFromProps = function (props) {
        var visibleColumns = utilities_1.ColumnHelper.GetSelectedColumns(props.columns);
        return { visibleColumns: visibleColumns };
    };
    QuestionVariationRow.prototype.render = function () {
        var _this = this;
        var selectable = this.props.selectable;
        // setting the selected className because when using styled to override TableRow,
        // the TableRow component cannot set its own classname
        var className = this.props.isSelected ? 'tws-table-row-selected ' : '';
        return (React.createElement(exports.VariationRow, { selectable: selectable, className: className + 'tws-alternate-question-row', selected: this.props.isSelected, onSelectRow: function () { return _this.props.SelectQuestionVariation(!_this.props.isSelected); }, disabled: this.props.disabled }, (0, lodash_1.default)(this.state.visibleColumns)
            .sortBy('displayOrder')
            .map(function (column) { return _this.getQuestionVariationPropertyText(column); })
            .value()));
    };
    QuestionVariationRow.prototype.getLanguageContent = function () {
        var languageCount = this.props.QuestionVariation.languageCount;
        return languageCount > 0 ? (React.createElement(React.Fragment, null,
            languageCount,
            React.createElement(common_1.ModalOpenButton, { id: this.props.QuestionVariation.questionVariationId, text: this.props.QuestionVariation.text, OpenModalCallback: this.props.LanguagesModalOpen }))) : (0);
    };
    QuestionVariationRow.prototype.getQuestionVariationPropertyText = function (column) {
        var _this = this;
        var _a = this.props, QuestionVariation = _a.QuestionVariation, showActionMenu = _a.showActionMenu, variationActionMenu = _a.variationActionMenu;
        var showActionMenuWrapper = showActionMenu ? showActionMenu(QuestionVariation) : true;
        var key = this.props.QuestionVariation.questionVariationId + '_' + column.name.toLowerCase();
        switch (column.name) {
            case 'text': {
                var text = this.props.QuestionVariation.text;
                return (React.createElement(aon_tws_common_ui_1.TableColumn, { key: key },
                    React.createElement(aon_tws_common_ui_1.SearchBolder, { text: text, searchText: this.props.searchText })));
            }
            case 'code': {
                var code = this.props.QuestionVariation.code;
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, code);
            }
            case 'allChosenLanguages': {
                var missingLanguages = this.GetMissingLanguages();
                var tooltipLangId = this.props.QuestionVariation.questionVariationId + '_QV_allChosenLanguages';
                return (React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, missingLanguages.length === 0 ? (React.createElement(aon_tws_common_ui_1.Icon, { name: 'yes' })) : (React.createElement(React.Fragment, null,
                    missingLanguages.length + " missing ",
                    React.createElement(aon_tws_common_ui_1.Tooltip, { id: tooltipLangId, iconName: 'error', contentType: 'jsx' },
                        React.createElement("div", null,
                            React.createElement("p", null,
                                React.createElement("strong", null, contentConstants_1.default.MISSING_LANGUAGES_TOOLTIP_TITLE_TEXT)),
                            React.createElement("ul", null, missingLanguages.map(function (id, liKey) {
                                var culture = _this.props.availableCultures.find(function (c) { return c.name === id; });
                                return React.createElement("li", { key: liKey }, culture ? culture.displayText : id);
                            })),
                            React.createElement("br", null),
                            contentConstants_1.default.MISSING_LANGUAGES_TOOLTIP_REMINDER_TEXT))))));
            }
            case 'isSelected':
                return null;
            case 'sourceType':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, utilities_1.ColumnHelper.GetSourceTypeContent(QuestionVariation.sourceType));
            case 'languages':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, this.getLanguageContent());
            case 'publicationStatus':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, utilities_1.ColumnHelper.GetStatusContent(QuestionVariation.publicationStatus));
            case 'actions':
                return (React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, showActionMenuWrapper && (React.createElement(aon_tws_common_ui_1.ActionMenuWrapper, null, variationActionMenu && variationActionMenu(QuestionVariation)))));
            default:
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key });
        }
    };
    QuestionVariationRow.prototype.GetMissingLanguages = function () {
        var _this = this;
        return this.props.supportedCultures.filter(function (id) { return _this.props.QuestionVariation.languages.indexOf(id) === -1; });
    };
    return QuestionVariationRow;
}(React.PureComponent));
exports.QuestionVariationRow = QuestionVariationRow;
var templateObject_1;
